module.exports = __webpack_public_path__ + "static/media/chad.da62e73e.png";